import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Tab,
  Tabs,
  Badge,
  Card,
  Accordion,
  Alert,
} from 'react-bootstrap';
import {
  FaLock,
  FaLockOpen,
  FaFileAlt,
  FaHistory,
  FaClipboardList,
  FaWindowClose,
  FaUser,
  FaClock,
  FaCheckSquare,
  FaSquare,
  FaUsers,
  FaHome,
  FaFile,
  FaEye,
  FaCheck,
  FaTimes,
  FaSpinner,
  FaExternalLinkAlt,
  FaFilePdf,
  FaFileImage,
  FaMoneyBillWave,
  FaExclamationTriangle,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import * as api from '~/Services/Service';
import { obterDocumentoDigitalCessao, downloadDocumentoCessao, cessaoInfosBoleto, desbloquearSolicitacaoCessao } from '~/Services/Service';
import Loading from '~/Components/Loading';
import {
  formatCpfCnpj,
  MOTIVOS_REPROVACAO,
} from './constants';
import {
  obterBloqueiosDecisao,
  obterChaveCampoParticipante,
  obterChaveParticipante,
  obterChaveRenderizacaoParticipante,
  obterChaveRenderizacaoDocumento,
  obterDescricaoInconsistenciaDocumento,
  obterIdentificadorDocumento,
  obterMensagemFalhaDownload,
  obterMensagemErroIdentidadeParticipante,
  obterParticipantesSemIdentificadorEstavel,
  obterPessoaDaConferencia,
  obterChavesPessoa,
  construirAnaliseDocumentos,
  construirResumoDocumental,
  formatarTelefoneCessao,
  classificarConferenciaCessao,
  MENSAGEM_DECISAO_INCOMPLETA,
} from './modalDetalhesHelpers';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const limparZerosPercentual = texto => {
  if (!texto) return texto;
  return texto.replace(/(\d+)\.0+(%)/g, '$1$2').replace(/(\d+\.\d*?)0+(%)/g, '$1$2');
};

const ESTADOS_CIVIS_MAP = {
  C: 'Casado(a)',
  S: 'Solteiro(a)',
  D: 'Divorciado(a)',
  V: 'Viúvo(a)',
  U: 'União Estável',
  P: 'Separado(a)',
  E: 'Separado(a)',
  B: 'Separado(a)',
};

const getLoteKeys = () => {
  return [
    'lote_empreendimento',
    'lote_quadra',
    'lote_lote',
    'lote_area_total',
    'lote_cidade',
    'lote_tipo_cessao',
  ];
};

const getSolicitacaoKeys = () => {
  return ['solicitacao_ligacao_agua', 'solicitacao_construcao'];
};

const CampoConferencia = ({
  label,
  valor,
  conferido,
  onConferir,
  temAnexo,
  anexoStatus,
  onVerAnexo,
  editavelCliente = false,
  invalido = false,
  motivoInvalidez = '',
  onMarcarInvalido,
  disabled = false,
}) => {
  const podeConferir =
    !disabled && (!temAnexo || anexoStatus === 2 || anexoStatus === 3);

  return (
    <div
      className={`d-flex align-items-start mb-2 py-2 border-bottom ${
        invalido ? 'bg-danger-light' : ''
      }`}
      style={{
        backgroundColor: invalido ? '#f8d7da' : 'transparent',
        borderRadius: invalido ? '4px' : '0',
        padding: invalido ? '8px' : undefined,
      }}
    >
      <div className="mr-2" style={{ minWidth: 24 }}>
        <Form.Check
          type="checkbox"
          checked={conferido}
          onChange={e => onConferir(e.target.checked)}
          disabled={!podeConferir}
          className="mt-1"
        />
      </div>
      <div className="flex-grow-1">
        <small className="text-muted d-block">
          {label}
          {editavelCliente && (
            <Badge
              variant="info"
              className="ml-2"
              style={{ fontSize: '0.65rem' }}
            >
              Editável pelo cliente
            </Badge>
          )}
          {invalido && !editavelCliente && (
            <Badge
              variant="danger"
              className="ml-2"
              style={{ fontSize: '0.65rem' }}
            >
              Exige atendimento interno
            </Badge>
          )}
        </small>
        <span
          className={invalido ? 'text-danger' : conferido ? 'text-success' : ''}
        >
          {valor || '-'}
        </span>
        {invalido && motivoInvalidez && (
          <small className="d-block text-danger mt-1">
            <FaTimes size={10} className="mr-1" />
            {motivoInvalidez}
          </small>
        )}
      </div>

      {onMarcarInvalido && conferido && !disabled && (
        <div className="ml-2">
          <Button
            variant={invalido ? 'danger' : 'outline-danger'}
            size="sm"
            onClick={() => onMarcarInvalido(!invalido)}
            title={
              invalido ? 'Desmarcar como inválido' : 'Marcar como inválido'
            }
          >
            <FaTimes size={12} />
          </Button>
        </div>
      )}
      {temAnexo && (
        <div className="ml-2 d-flex align-items-center">
          <Button
            variant="link"
            size="sm"
            onClick={onVerAnexo}
            className="p-0 mr-2"
          >
            <FaEye /> Ver
          </Button>
          {anexoStatus === 2 && (
            <Badge variant="success">
              <FaCheck /> Aprovado
            </Badge>
          )}
          {anexoStatus === 3 && (
            <Badge variant="danger">
              <FaTimes /> Reprovado
            </Badge>
          )}
          {(!anexoStatus || anexoStatus === 1) && (
            <Badge variant="warning">Pendente</Badge>
          )}
        </div>
      )}
    </div>
  );
};

const CampoConferenciaPessoa = ({ disabled, ...props }) => (
  <CampoConferencia
    {...props}
    onConferir={valor => {
      if (!disabled) props.onConferir(valor);
    }}
    onMarcarInvalido={
      props.onMarcarInvalido
        ? valor => {
            if (!disabled) props.onMarcarInvalido(valor);
          }
        : undefined
    }
    disabled={disabled}
  />
);

const DocumentoItem = ({
  documento,
  onVerAnexo,
  validacao,
  onValidar,
  disabled,
  erroDownload,
}) => {
  const getIconeDocumento = caminho => {
    if (!caminho) return <FaFile />;
    const ext = caminho
      .split('.')
      .pop()
      .toLowerCase();
    if (ext === 'pdf') return <FaFilePdf className="text-danger" />;
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext))
      return <FaFileImage className="text-primary" />;
    return <FaFile />;
  };

  const statusAtual = validacao;
  const identificadorDocumento = obterIdentificadorDocumento(documento);
  const podeValidar = Boolean(identificadorDocumento) && !disabled;

  return (
    <div
      className={`d-flex align-items-center justify-content-between p-3 rounded mb-2 ${
        statusAtual === true
          ? 'bg-success-light border-success'
          : statusAtual === false
          ? 'bg-danger-light border-danger'
          : 'bg-warning-light border-warning'
      }`}
      style={{
        border: '2px solid',
        borderColor:
          statusAtual === true
            ? '#28a745'
            : statusAtual === false
            ? '#dc3545'
            : '#ffc107',
        backgroundColor:
          statusAtual === true
            ? '#d4edda'
            : statusAtual === false
            ? '#f8d7da'
            : '#fff3cd',
      }}
    >
      <div className="d-flex align-items-center flex-grow-1">
        <span className="mr-3" style={{ fontSize: '1.5rem' }}>
          {getIconeDocumento(documento.caminho_arquivo)}
        </span>
        <div className="flex-grow-1">
          <strong className="d-block">
            {documento.tipo_documento_descricao || 'Documento'}
          </strong>
          <small className="text-muted">
            {documento.caminho_arquivo
              ? documento.caminho_arquivo
                  .split('\\')
                  .pop()
                  .split('/')
                  .pop()
              : 'Arquivo não disponível'}
          </small>
          {erroDownload && (
            <small className="d-block text-danger mt-1">{erroDownload}</small>
          )}
        </div>
      </div>

      <div className="d-flex align-items-center">
        <div className="mr-3 text-center" style={{ minWidth: 80 }}>
          {statusAtual === true && (
            <Badge variant="success" className="px-2 py-1">
              <FaCheck className="mr-1" /> Aprovado
            </Badge>
          )}
          {statusAtual === false && (
            <Badge variant="danger" className="px-2 py-1">
              <FaTimes className="mr-1" /> Reprovado
            </Badge>
          )}
          {statusAtual === null || statusAtual === undefined ? (
            <Badge variant="warning" className="px-2 py-1">
              Pendente
            </Badge>
          ) : null}
        </div>

        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => onVerAnexo(documento)}
          title="Visualizar documento"
          className="mr-2"
        >
          <FaEye className="mr-1" />
          Ver
        </Button>

        <div className="btn-group">
          <Button
            variant={statusAtual === true ? 'success' : 'outline-success'}
            size="sm"
            onClick={() => onValidar(identificadorDocumento, true)}
            disabled={!podeValidar}
            title="Aprovar documento"
          >
            <FaCheck />
          </Button>
          <Button
            variant={statusAtual === false ? 'danger' : 'outline-danger'}
            size="sm"
            onClick={() => onValidar(identificadorDocumento, false)}
            disabled={!podeValidar}
            title="Invalidar documento"
          >
            <FaTimes />
          </Button>
        </div>
      </div>
    </div>
  );
};

const SecaoPessoa = ({
  pessoa,
  titulo,
  tipo,
  conferencias,
  onConferir,
  onVerAnexo,
  documentosValidacao,
  onValidarDocumento,
  disabled,
  camposInvalidos = {},
  onMarcarInvalido,
  errosDownload = {},
}) => {
  if (!pessoa) return null;

  const baseKey = obterChaveParticipante(pessoa, tipo);
  const keys = obterChavesPessoa(pessoa, tipo);
  const conferenciasPessoa = baseKey ? conferencias : {};
  const camposInvalidosPessoa = baseKey ? camposInvalidos : {};
  const campoDesabilitado = !baseKey || disabled;
  const conferido =
    Boolean(baseKey) && keys.length > 0 && keys.every(k => conferencias[k]);
  const documentos = pessoa.documentos || [];

  const handleCheckAll = () => {
    if (campoDesabilitado) return;
    const newValue = !conferido;
    keys.forEach(k => onConferir(k, newValue));
  };

  const formatarEndereco = p => {
    const partes = [];
    if (p.logradouro) partes.push(p.logradouro);
    if (p.numero) partes.push(p.numero);
    if (p.complemento) partes.push(p.complemento);
    if (p.bairro) partes.push(p.bairro);
    if (p.cidade) partes.push(p.cidade);
    if (p.estado) partes.push(p.estado);
    if (p.cep) partes.push('CEP: ' + p.cep);
    return partes.join(', ') || '-';
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex align-items-center justify-content-between py-2">
        <div className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            checked={conferido}
            onChange={handleCheckAll}
            disabled={campoDesabilitado}
            className="mr-2"
          />
          <strong>
            <FaUser className="mr-2" />
            {titulo}
            {pessoa.tipo && pessoa.tipo !== 'Principal' && (
              <Badge variant="secondary" className="ml-2">
                {pessoa.tipo}
              </Badge>
            )}
          </strong>
        </div>
        <div className="d-flex align-items-center">
          {documentos.length > 0 && (
            <Badge variant="info" className="mr-2">
              <FaFile size={10} className="mr-1" />
              {documentos.length} doc(s)
            </Badge>
          )}
          {pessoa.tipo_pessoa === '1' && (
            <Badge variant="warning">Pessoa Jurídica</Badge>
          )}
        </div>
      </Card.Header>
      <Card.Body className="py-2">
        {!baseKey && (
          <Alert variant="danger" className="mb-3">
            <strong>Participante sem identificador estável.</strong> Não é
            possível recuperar a conferência com segurança. Informe o código
            legado e o nome ao suporte.
          </Alert>
        )}
        <Row>
          <Col md={6}>
            <CampoConferenciaPessoa
              disabled={campoDesabilitado}
              label="Nome"
              valor={pessoa.nome}
              conferido={conferenciasPessoa[baseKey + '_nome']}
              onConferir={val => onConferir(baseKey + '_nome', val)}
              editavelCliente={false}
              invalido={camposInvalidosPessoa[baseKey + '_nome']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido(baseKey + '_nome', val)
              }
            />
          </Col>
          <Col md={6}>
            <CampoConferenciaPessoa
              disabled={campoDesabilitado}
              label="CPF/CNPJ"
              valor={formatCpfCnpj(pessoa.cpf)}
              conferido={conferenciasPessoa[baseKey + '_cpf']}
              onConferir={val => onConferir(baseKey + '_cpf', val)}
              editavelCliente={false}
              invalido={camposInvalidosPessoa[baseKey + '_cpf']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido(baseKey + '_cpf', val)
              }
            />
          </Col>
        </Row>

        {pessoa.tipo_pessoa !== '1' && (
          <>
            <Row>
              <Col md={4}>
                <CampoConferenciaPessoa
                  disabled={campoDesabilitado}
                  label="RG"
                  valor={pessoa.rg}
                  conferido={conferenciasPessoa[baseKey + '_rg']}
                  onConferir={val => onConferir(baseKey + '_rg', val)}
                  editavelCliente={false}
                  invalido={camposInvalidosPessoa[baseKey + '_rg']}
                  onMarcarInvalido={val =>
                    onMarcarInvalido && onMarcarInvalido(baseKey + '_rg', val)
                  }
                />
              </Col>
              <Col md={4}>
                <CampoConferenciaPessoa
                  disabled={campoDesabilitado}
                  label="Estado Civil"
                  valor={
                    pessoa.estado_civil_descricao ||
                    ESTADOS_CIVIS_MAP[pessoa.estado_civil] ||
                    pessoa.estado_civil
                  }
                  conferido={conferenciasPessoa[baseKey + '_estado_civil']}
                  onConferir={val => onConferir(baseKey + '_estado_civil', val)}
                  editavelCliente={false}
                  invalido={camposInvalidosPessoa[baseKey + '_estado_civil']}
                  onMarcarInvalido={val =>
                    onMarcarInvalido &&
                    onMarcarInvalido(baseKey + '_estado_civil', val)
                  }
                />
              </Col>
              <Col md={4}>
                <CampoConferenciaPessoa
                  disabled={campoDesabilitado}
                  label="Data de Nascimento"
                  valor={
                    pessoa.data_nascimento
                      ? moment(pessoa.data_nascimento).format('DD/MM/YYYY')
                      : '-'
                  }
                  conferido={conferenciasPessoa[baseKey + '_data_nascimento']}
                  onConferir={val =>
                    onConferir(baseKey + '_data_nascimento', val)
                  }
                  editavelCliente={false}
                  invalido={camposInvalidosPessoa[baseKey + '_data_nascimento']}
                  onMarcarInvalido={val =>
                    onMarcarInvalido &&
                    onMarcarInvalido(baseKey + '_data_nascimento', val)
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <CampoConferenciaPessoa
                  disabled={campoDesabilitado}
                  label="Profissão"
                  valor={pessoa.profissao}
                  conferido={conferenciasPessoa[baseKey + '_profissao']}
                  onConferir={val => onConferir(baseKey + '_profissao', val)}
                  editavelCliente={false}
                  invalido={camposInvalidosPessoa[baseKey + '_profissao']}
                  onMarcarInvalido={val =>
                    onMarcarInvalido &&
                    onMarcarInvalido(baseKey + '_profissao', val)
                  }
                />
              </Col>
              <Col md={6}>
                <CampoConferenciaPessoa
                  disabled={campoDesabilitado}
                  label="Nacionalidade"
                  valor={pessoa.nacionalidade}
                  conferido={conferenciasPessoa[baseKey + '_nacionalidade']}
                  onConferir={val =>
                    onConferir(baseKey + '_nacionalidade', val)
                  }
                  editavelCliente={false}
                  invalido={camposInvalidosPessoa[baseKey + '_nacionalidade']}
                  onMarcarInvalido={val =>
                    onMarcarInvalido &&
                    onMarcarInvalido(baseKey + '_nacionalidade', val)
                  }
                />
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col md={6}>
            <CampoConferenciaPessoa
              disabled={campoDesabilitado}
              label="E-mail"
              valor={pessoa.email}
              conferido={conferenciasPessoa[baseKey + '_email']}
              onConferir={val => onConferir(baseKey + '_email', val)}
              editavelCliente={true}
              invalido={camposInvalidosPessoa[baseKey + '_email']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido(baseKey + '_email', val)
              }
            />
          </Col>
          <Col md={6}>
            <CampoConferenciaPessoa
              disabled={campoDesabilitado}
              label="Telefone"
              valor={formatarTelefoneCessao(
                pessoa.telefone ||
                  pessoa.telefone_celular ||
                  pessoa.telefone_comercial
              )}
              conferido={conferenciasPessoa[baseKey + '_telefone']}
              onConferir={val => onConferir(baseKey + '_telefone', val)}
              editavelCliente={true}
              invalido={camposInvalidosPessoa[baseKey + '_telefone']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido(baseKey + '_telefone', val)
              }
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <CampoConferenciaPessoa
              disabled={campoDesabilitado}
              label="Endereço"
              valor={formatarEndereco(pessoa)}
              conferido={conferenciasPessoa[baseKey + '_endereco']}
              onConferir={val => onConferir(baseKey + '_endereco', val)}
              editavelCliente={true}
              invalido={camposInvalidosPessoa[baseKey + '_endereco']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido(baseKey + '_endereco', val)
              }
            />
          </Col>
        </Row>

        {pessoa.nome_conjuge && (
          <Row>
            <Col md={12}>
              <CampoConferenciaPessoa
                disabled={campoDesabilitado}
                label="Cônjuge"
                valor={pessoa.nome_conjuge}
                conferido={conferenciasPessoa[baseKey + '_conjuge']}
                onConferir={val => onConferir(baseKey + '_conjuge', val)}
                editavelCliente={false}
                invalido={camposInvalidosPessoa[baseKey + '_conjuge']}
                onMarcarInvalido={val =>
                  onMarcarInvalido &&
                  onMarcarInvalido(baseKey + '_conjuge', val)
                }
              />
            </Col>
          </Row>
        )}

        {documentos.length > 0 && (
          <div className="mt-3 pt-3 border-top">
            <h6 className="mb-3 d-flex align-items-center">
              <FaFile className="mr-2 text-primary" />
              <span>
                Documentos de{' '}
                {pessoa.nome ? pessoa.nome.split(' ')[0] || titulo : titulo}
              </span>
              <Badge variant="primary" className="ml-2">
                {documentos.length}
              </Badge>
            </h6>
            {documentos.map((doc, idx) => (
              <DocumentoItem
                key={obterChaveRenderizacaoDocumento(doc, idx)}
                documento={doc}
                onVerAnexo={onVerAnexo}
                validacao={
                  obterIdentificadorDocumento(doc)
                    ? documentosValidacao[obterIdentificadorDocumento(doc)]
                    : undefined
                }
                onValidar={onValidarDocumento}
                disabled={disabled}
                erroDownload={
                  obterIdentificadorDocumento(doc)
                    ? errosDownload[obterIdentificadorDocumento(doc)]
                    : undefined
                }
              />
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

const SecaoLote = ({
  lote,
  conferencias,
  onConferir,
  onVerAnexo,
  documentosValidacao,
  onValidarDocumento,
  disabled,
  camposInvalidos = {},
  onMarcarInvalido,
  errosDownload = {},
}) => {
  if (!lote) return null;

  const keys = getLoteKeys();
  const conferido = keys.every(k => conferencias[k]);
  const documentos = lote.documentos || [];

  const handleCheckAll = () => {
    const newValue = !conferido;
    keys.forEach(k => onConferir(k, newValue));
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex align-items-center justify-content-between py-2">
        <div className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            checked={conferido}
            onChange={handleCheckAll}
            className="mr-2"
          />
          <strong>
            <FaHome className="mr-2" />
            Dados do Lote / Imóvel
          </strong>
        </div>
        {documentos.length > 0 && (
          <Badge variant="info">
            <FaFile size={10} className="mr-1" />
            {documentos.length} doc(s) do imóvel
          </Badge>
        )}
      </Card.Header>
      <Card.Body className="py-2">
        <Row>
          <Col md={6}>
            <CampoConferencia
              label="Empreendimento"
              valor={lote.empreendimento}
              conferido={conferencias['lote_empreendimento']}
              onConferir={val => onConferir('lote_empreendimento', val)}
              editavelCliente={false}
              invalido={camposInvalidos['lote_empreendimento']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido('lote_empreendimento', val)
              }
            />
          </Col>
          <Col md={3}>
            <CampoConferencia
              label="Quadra"
              valor={lote.quadra}
              conferido={conferencias['lote_quadra']}
              onConferir={val => onConferir('lote_quadra', val)}
              editavelCliente={false}
              invalido={camposInvalidos['lote_quadra']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido('lote_quadra', val)
              }
            />
          </Col>
          <Col md={3}>
            <CampoConferencia
              label="Lote"
              valor={lote.lote}
              conferido={conferencias['lote_lote']}
              onConferir={val => onConferir('lote_lote', val)}
              editavelCliente={false}
              invalido={camposInvalidos['lote_lote']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido('lote_lote', val)
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <CampoConferencia
              label="Área Total"
              valor={lote.area_total}
              conferido={conferencias['lote_area_total']}
              onConferir={val => onConferir('lote_area_total', val)}
              editavelCliente={false}
              invalido={camposInvalidos['lote_area_total']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido('lote_area_total', val)
              }
            />
          </Col>
          <Col md={4}>
            <CampoConferencia
              label="Cidade/UF"
              valor={lote.cidade ? lote.cidade + '/' + lote.estado : '-'}
              conferido={conferencias['lote_cidade']}
              onConferir={val => onConferir('lote_cidade', val)}
              editavelCliente={false}
              invalido={camposInvalidos['lote_cidade']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido('lote_cidade', val)
              }
            />
          </Col>
          <Col md={4}>
            <CampoConferencia
              label="Tipo Cessão"
              valor={lote.tipo_cessao}
              conferido={conferencias['lote_tipo_cessao']}
              onConferir={val => onConferir('lote_tipo_cessao', val)}
              editavelCliente={false}
              invalido={camposInvalidos['lote_tipo_cessao']}
              onMarcarInvalido={val =>
                onMarcarInvalido && onMarcarInvalido('lote_tipo_cessao', val)
              }
            />
          </Col>
        </Row>

        {documentos.length > 0 && (
          <div className="mt-3 pt-3 border-top">
            <h6 className="mb-3 d-flex align-items-center">
              <FaFile className="mr-2 text-info" />
              <span>Documentos do Imóvel</span>
              <Badge variant="info" className="ml-2">
                {documentos.length}
              </Badge>
            </h6>
            {documentos.map((doc, idx) => (
              <DocumentoItem
                key={obterChaveRenderizacaoDocumento(doc, idx)}
                documento={doc}
                onVerAnexo={onVerAnexo}
                validacao={
                  obterIdentificadorDocumento(doc)
                    ? documentosValidacao[obterIdentificadorDocumento(doc)]
                    : undefined
                }
                onValidar={onValidarDocumento}
                disabled={disabled}
                erroDownload={
                  obterIdentificadorDocumento(doc)
                    ? errosDownload[obterIdentificadorDocumento(doc)]
                    : undefined
                }
              />
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

const SecaoDocumentosInconsistentes = ({
  documentosInconsistentes,
  totalDocumentos,
  onVerAnexo,
  documentosValidacao,
  onValidarDocumento,
  disabled,
  errosDownload = {},
}) => {
  if (!documentosInconsistentes || documentosInconsistentes.length === 0) {
    return null;
  }

  return (
    <Alert variant="danger" className="mb-3">
      <Alert.Heading className="h6">
        <FaExclamationTriangle className="mr-2" />
        Documentos que precisam de atenção
        <Badge variant="danger" className="ml-2">
          {documentosInconsistentes.length}
        </Badge>
      </Alert.Heading>
      <p className="mb-3">
        {totalDocumentos
          ? `A solicitação contabiliza ${totalDocumentos} documento(s). `
          : ''}
        Estes documentos continuam disponíveis para análise, mas não podem ser
        ignorados. A decisão seguirá a regra do contrato e pode ficar bloqueada
        até a inconsistência ser resolvida.
      </p>
      {documentosInconsistentes.map((inconsistencia, indice) => {
        const identificadorDocumento = obterIdentificadorDocumento(
          inconsistencia.documento
        );
        const nomeParticipantes = (inconsistencia.associacoes || [])
          .map(associacao => associacao.nome)
          .filter(Boolean)
          .join(', ');

        return (
          <div key={obterChaveRenderizacaoDocumento(inconsistencia.documento, indice)} className="mb-3 p-2 bg-white rounded border">
            <DocumentoItem
              documento={inconsistencia.documento}
              onVerAnexo={onVerAnexo}
              validacao={
                identificadorDocumento
                  ? documentosValidacao[identificadorDocumento]
                  : undefined
              }
              onValidar={onValidarDocumento}
              disabled={disabled}
              erroDownload={
                identificadorDocumento
                  ? errosDownload[identificadorDocumento]
                  : undefined
              }
            />
            <small className="d-block text-danger">
              <strong>Motivo:</strong>{' '}
              {inconsistencia.motivos
                .map(obterDescricaoInconsistenciaDocumento)
                .join('; ')}
              {nomeParticipantes && (
                <>
                  <br />
                  <strong>Participante:</strong> {nomeParticipantes}
                </>
              )}
              <br />
              <strong>Código do documento:</strong>{' '}
              {identificadorDocumento || 'não informado'}
            </small>
          </div>
        );
      })}
    </Alert>
  );
};

const SecaoSolicitacao = ({
  detalhes,
  conferencias,
  onConferir,
  camposInvalidos = {},
  onMarcarInvalido,
}) => {
  if (!detalhes) return null;

  const keys = getSolicitacaoKeys();
  const conferido = keys.every(k => conferencias[k]);

  const handleCheckAll = () => {
    const newValue = !conferido;
    keys.forEach(k => onConferir(k, newValue));
  };

  const formatarSimNao = valor => {
    if (valor === true) return 'Sim';
    if (valor === false) return 'Não';
    return '-';
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex align-items-center justify-content-between py-2">
        <div className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            checked={conferido}
            onChange={handleCheckAll}
            className="mr-2"
          />
          <strong>
            <FaClipboardList className="mr-2" />
            Dados da Solicitação
          </strong>
        </div>
      </Card.Header>
      <Card.Body className="py-2">
        <Row>
          <Col md={4}>
            <CampoConferencia
              label="Possui Ligação de Água?"
              valor={formatarSimNao(detalhes.possui_ligacao_agua)}
              conferido={conferencias['solicitacao_ligacao_agua']}
              onConferir={val => onConferir('solicitacao_ligacao_agua', val)}
              editavelCliente={false}
              invalido={camposInvalidos['solicitacao_ligacao_agua']}
              onMarcarInvalido={val =>
                onMarcarInvalido &&
                onMarcarInvalido('solicitacao_ligacao_agua', val)
              }
            />
          </Col>
          <Col md={4}>
            <CampoConferencia
              label="Possui Construção?"
              valor={formatarSimNao(detalhes.possui_construcao)}
              conferido={conferencias['solicitacao_construcao']}
              onConferir={val => onConferir('solicitacao_construcao', val)}
              editavelCliente={false}
              invalido={camposInvalidos['solicitacao_construcao']}
              onMarcarInvalido={val =>
                onMarcarInvalido &&
                onMarcarInvalido('solicitacao_construcao', val)
              }
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const obterEstadoVisualResumoDocumental = (
  resumo,
  totalInconsistenciasDocumentais
) => {
  if (totalInconsistenciasDocumentais > 0) return 'inconsistente';
  if (resumo.temReprovacao) return 'reprovado';
  if (resumo.pendentes > 0) return 'pendente';
  if (resumo.todosAprovados) return 'aprovado';
  return 'vazio';
};

const obterClasseResumoDocumental = estado => {
  if (estado === 'aprovado') return 'bg-success text-white';
  if (estado === 'reprovado' || estado === 'inconsistente') {
    return 'bg-danger text-white';
  }
  if (estado === 'pendente') return 'bg-warning text-dark';
  return 'bg-light';
};

const obterDescricaoDocumentoAguardando = item =>
  item.descricaoCampo || item.nomeCampo || 'Documento não identificado';

const descreverQuantidade = (quantidade, singular, plural) =>
  `${quantidade} ${quantidade === 1 ? singular : plural}`;

const obterIdentificacaoParticipanteAguardando = (item, participantes) => {
  if (item.identificadorParticipante) {
    const participantesCorrespondentes = participantes.filter(
      participante =>
        participante.identificador_participante !== null &&
        participante.identificador_participante !== undefined &&
        String(participante.identificador_participante) ===
          String(item.identificadorParticipante)
    );
    if (
      participantesCorrespondentes.length === 1 &&
      participantesCorrespondentes[0].nome
    ) {
      return {
        rotulo: 'Participante',
        valor: participantesCorrespondentes[0].nome,
      };
    }
  }
  if (item.documento) {
    return {
      rotulo: 'CPF/CNPJ do participante',
      valor: formatCpfCnpj(item.documento),
    };
  }
  if (item.identificadorParticipante) {
    return {
      rotulo: 'Identificador do participante',
      valor: String(item.identificadorParticipante),
    };
  }
  return null;
};

export const ResumoDocumentalCard = ({
  resumo,
  participantes = [],
  inconsistenciasDocumentosAtuais = 0,
}) => {
  const totalInconsistenciasDocumentais =
    resumo.inconsistencias.length + inconsistenciasDocumentosAtuais;
  const estado = obterEstadoVisualResumoDocumental(
    resumo,
    totalInconsistenciasDocumentais
  );
  const textoClaro =
    estado === 'aprovado' ||
    estado === 'reprovado' ||
    estado === 'inconsistente';

  return (
    <div data-testid="resumo-documental">
      <div
        data-testid="resumo-documental-estado"
        data-estado={estado}
        className={`text-center p-3 rounded ${obterClasseResumoDocumental(
          estado
        )}`}
      >
        <h4 className="mb-0">
          {resumo.aprovados}/{resumo.totalLogico}
        </h4>
        <small className={textoClaro ? 'text-white' : 'text-muted'}>
          Documentos aprovados
        </small>

        {estado === 'aprovado' && (
          <div className="mt-1">
            <FaCheck /> Todos os documentos aprovados
          </div>
        )}
        {estado === 'vazio' && (
          <div className="mt-1 text-muted">Nenhum documento disponível</div>
        )}
        {resumo.reprovadosAtuais > 0 && (
          <div className="mt-1">
            <FaTimes />{' '}
            {descreverQuantidade(
              resumo.reprovadosAtuais,
              'documento reprovado',
              'documentos reprovados'
            )}
          </div>
        )}
        {resumo.pendentes > 0 && (
          <div className="mt-1">
            <FaClock />{' '}
            {descreverQuantidade(
              resumo.pendentes,
              'documento pendente de conferência',
              'documentos pendentes de conferência'
            )}
          </div>
        )}
        {resumo.reprovadosAguardandoReenvio > 0 && (
          <div className="mt-1">
            <FaExclamationTriangle />{' '}
            {descreverQuantidade(
              resumo.reprovadosAguardandoReenvio,
              'documento aguardando reenvio do cliente',
              'documentos aguardando reenvio do cliente'
            )}
          </div>
        )}
        {totalInconsistenciasDocumentais > 0 && (
          <div className="mt-1">
            <FaExclamationTriangle />{' '}
            {descreverQuantidade(
              totalInconsistenciasDocumentais,
              'inconsistência documental',
              'inconsistências documentais'
            )}
          </div>
        )}
      </div>

      {resumo.itensAguardandoReenvio.length > 0 && (
        <div
          data-testid="documentos-aguardando-reenvio"
          className="mt-3 text-left"
        >
          <strong className="d-block mb-2">
            Documentos aguardando reenvio
          </strong>
          {resumo.itensAguardandoReenvio.map((item, indice) => {
            const participante = obterIdentificacaoParticipanteAguardando(
              item,
              participantes
            );
            return (
              <div
                data-testid="documento-aguardando-reenvio"
                key={`conferencia-${item.codigoConferencia || 'sem-codigo'}-${
                  item.codigoDocumento || 'sem-documento'
                }-${indice}`}
                className="mb-2 p-2 rounded border border-danger bg-light"
              >
                <div className="text-danger">
                  <FaExclamationTriangle className="mr-2" />
                  <strong>{obterDescricaoDocumentoAguardando(item)}</strong>
                </div>
                <small className="d-block text-danger">
                  Aguardando reenvio do cliente
                </small>
                {participante && (
                  <small className="d-block text-muted">
                    {participante.rotulo}: {participante.valor}
                  </small>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const ModalDetalhes = ({ show, onHide, solicitacao, onStatusChange, onSuccess }) => {
  const [activeTab, setActiveTab] = useState('formulario');
  const [historico, setHistorico] = useState([]);
  const [isLoadingHistorico, setIsLoadingHistorico] = useState(false);
  const [selectedHistorico, setSelectedHistorico] = useState(null);
  const [detalhes, setDetalhes] = useState(null);
  const [isLoadingDetalhes, setIsLoadingDetalhes] = useState(false);
  const [conferencias, setConferencias] = useState({});
  const [conferenciasPersistidas, setConferenciasPersistidas] = useState([]);
  const codigoSolicitacaoAtivaRef = useRef(null);
  const geracaoCarregamentoDetalhesRef = useRef(0);

  const [decisao, setDecisao] = useState(null);
  const [motivoReprovacao, setMotivoReprovacao] = useState('');
  const [observacao, setObservacao] = useState('');
  const [enviarEmail, setEnviarEmail] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSavingProgress, setIsSavingProgress] = useState(false);
  const [documentosValidacao, setDocumentosValidacao] = useState({});
  const [camposInvalidos, setCamposInvalidos] = useState({});
  // Editabilidade canônica devolvida pela WebAPI para campos já persistidos
  // (chave da UI -> editavel_cliente). Item ainda não salvo não tem entrada
  // aqui e usa o catálogo local (campoEditavelCliente) na classificação.
  const [editavelClientePersistido, setEditavelClientePersistido] = useState(
    {}
  );
  const [errosDownload, setErrosDownload] = useState({});
  const [documentoDigital, setDocumentoDigital] = useState(null);
  const [isLoadingDocumento, setIsLoadingDocumento] = useState(false);
  const [isDesbloqueando, setIsDesbloqueando] = useState(false);
  const [infosBoleto, setInfosBoleto] = useState(null);
  const [isLoadingInfosBoleto, setIsLoadingInfosBoleto] = useState(false);

  const isInativa = solicitacao && solicitacao.status === 0;

  useEffect(() => {
    const codigoSolicitacaoAtiva =
      show && solicitacao ? solicitacao.codigo : null;
    geracaoCarregamentoDetalhesRef.current += 1;
    codigoSolicitacaoAtivaRef.current = codigoSolicitacaoAtiva;
    setConferenciasPersistidas([]);
    setDetalhes(null);

    if (codigoSolicitacaoAtiva === null) {
      setIsLoadingDetalhes(false);
      return;
    }

    if (show && solicitacao) {
      setSelectedHistorico(null);
      setConferencias({});
      setDecisao(null);
      setMotivoReprovacao('');
      setObservacao('');
      setEnviarEmail(true);
      setDocumentosValidacao({});
      setCamposInvalidos({});
      setEditavelClientePersistido({});
      setErrosDownload({});
      setDocumentoDigital(null);
      setInfosBoleto(null);

      if (isInativa) {
        setActiveTab('historico');
        carregarDetalhes(codigoSolicitacaoAtiva);
        carregarHistorico();
      } else {
        setActiveTab('formulario');
        carregarDetalhes(codigoSolicitacaoAtiva);
        carregarHistorico();
        carregarDocumentoDigital();
        carregarInfosBoleto();
      }
    }
  }, [show, solicitacao]);

  const solicitacaoContinuaAtiva = (codigoSolicitacao, geracaoCarregamento) =>
    codigoSolicitacaoAtivaRef.current !== null &&
    String(codigoSolicitacaoAtivaRef.current) === String(codigoSolicitacao) &&
    geracaoCarregamentoDetalhesRef.current === geracaoCarregamento;

  const carregarDetalhes = async (
    codigoSolicitacao = solicitacao && solicitacao.codigo
  ) => {
    if (codigoSolicitacao === null || codigoSolicitacao === undefined) return;
    const geracaoCarregamento =
      geracaoCarregamentoDetalhesRef.current + 1;
    geracaoCarregamentoDetalhesRef.current = geracaoCarregamento;
    setIsLoadingDetalhes(true);
    try {
      const data = await api.obterDetalhesCessao(codigoSolicitacao);
      if (
        !solicitacaoContinuaAtiva(codigoSolicitacao, geracaoCarregamento)
      ) {
        return;
      }
      setDetalhes(data);

      try {
        const conferencia = await api.obterConferenciaCamposCessao(
          codigoSolicitacao
        );
        if (
          !solicitacaoContinuaAtiva(codigoSolicitacao, geracaoCarregamento)
        ) {
          return;
        }
        setConferenciasPersistidas(
          Array.isArray(conferencia) ? conferencia : []
        );
        if (conferencia && Array.isArray(conferencia)) {
          const docsValidacao = {};
          conferencia.forEach(campo => {
            const identificadorDocumento = campo.codigo_documento;
            if (
              campo.tipo_registro === 'DOCUMENTO' &&
              identificadorDocumento != null &&
              identificadorDocumento !== ''
            ) {
              if (campo.valido !== null && campo.valido !== undefined) {
                docsValidacao[String(identificadorDocumento)] = campo.valido;
              }
            }
          });
          if (Object.keys(docsValidacao).length > 0) {
            setDocumentosValidacao(docsValidacao);
          }

          const conferenciasCarregadas = {};
          const camposInvalidosCarregados = {};
          // A editabilidade que a WebAPI já calculou para um campo não
          // depende de o campo estar aprovado, reprovado ou ainda pendente —
          // por isso essa marcação é lida à parte, sem a mesma condição que
          // popula `conferencias`/`camposInvalidos` (essas sim só fazem
          // sentido quando existe uma decisão registrada).
          const editavelClientePersistidoCarregado = {};
          conferencia.forEach(campo => {
            if (campo.tipo_registro !== 'DOCUMENTO') {
              const chave = montarChaveCampo(campo, data);
              if (chave) {
                if (campo.valido !== null && campo.valido !== undefined) {
                  conferenciasCarregadas[chave] = true;

                  if (campo.valido === false) {
                    camposInvalidosCarregados[chave] = true;
                  }
                }

                if (
                  campo.editavel_cliente !== null &&
                  campo.editavel_cliente !== undefined
                ) {
                  editavelClientePersistidoCarregado[chave] = Boolean(
                    campo.editavel_cliente
                  );
                }
              }
            } else if (
              campo.codigo_documento !== null &&
              campo.codigo_documento !== undefined &&
              campo.codigo_documento !== '' &&
              campo.editavel_cliente !== null &&
              campo.editavel_cliente !== undefined
            ) {
              const chaveDocumento = `documento_${String(
                campo.codigo_documento
              )}`;
              editavelClientePersistidoCarregado[chaveDocumento] = Boolean(
                campo.editavel_cliente
              );
            }
          });
          if (Object.keys(conferenciasCarregadas).length > 0) {
            setConferencias(conferenciasCarregadas);
          }
          if (Object.keys(editavelClientePersistidoCarregado).length > 0) {
            setEditavelClientePersistido(editavelClientePersistidoCarregado);
          }
          if (Object.keys(camposInvalidosCarregados).length > 0) {
            setCamposInvalidos(camposInvalidosCarregados);
          }
        }
      } catch (errConf) {
        if (
          !solicitacaoContinuaAtiva(codigoSolicitacao, geracaoCarregamento)
        ) {
          return;
        }
        setConferenciasPersistidas([]);
        console.log('Conferência não carregada:', errConf);
      }
    } catch (err) {
      if (
        !solicitacaoContinuaAtiva(codigoSolicitacao, geracaoCarregamento)
      ) {
        return;
      }
      setDetalhes(null);
      setConferenciasPersistidas([]);
      toast.error('Erro ao carregar detalhes da solicitação');
    } finally {
      if (
        solicitacaoContinuaAtiva(codigoSolicitacao, geracaoCarregamento)
      ) {
        setIsLoadingDetalhes(false);
      }
    }
  };

  const montarChaveCampo = (campo, detalhesData) => {
    if (!campo || !detalhesData) return null;

    const mapaInversoCampos = {
      Nome: '_nome',
      CPF: '_cpf',
      RG: '_rg',
      EstadoCivil: '_estado_civil',
      DataNascimento: '_data_nascimento',
      Profissao: '_profissao',
      Nacionalidade: '_nacionalidade',
      Email: '_email',
      Telefone: '_telefone',
      Endereco: '_endereco',
      NomeConjuge: '_conjuge',
    };

    const mapaInversoLote = {
      Empreendimento: 'lote_empreendimento',
      Quadra: 'lote_quadra',
      Lote: 'lote_lote',
      AreaTotal: 'lote_area_total',
      Cidade: 'lote_cidade',
      TipoCessao: 'lote_tipo_cessao',
    };

    const mapaInversoSolicitacao = {
      Possui_Ligacao_Agua: 'solicitacao_ligacao_agua',
      Possui_Construcao: 'solicitacao_construcao',
    };

    if (campo.tipo_registro === 'LOTE') {
      return mapaInversoLote[campo.nome_campo] || null;
    }

    if (campo.tipo_registro === 'SOLICITACAO') {
      return mapaInversoSolicitacao[campo.nome_campo] || null;
    }

    if (
      campo.tipo_registro === 'CEDENTE' ||
      campo.tipo_registro === 'CESSIONARIO'
    ) {
      const tipo =
        campo.tipo_registro === 'CEDENTE' ? 'cedente' : 'cessionario';
      const pessoas =
        tipo === 'cedente' ? detalhesData.cedentes : detalhesData.cessionarios;
      if (pessoas && Array.isArray(pessoas)) {
        const pessoa = obterPessoaDaConferencia(pessoas, campo);
        if (pessoa) {
          const sufixo = mapaInversoCampos[campo.nome_campo];
          if (sufixo) {
            return obterChaveCampoParticipante(pessoa, tipo, sufixo) || null;
          }
        }
      }
    }

    return null;
  };

  const carregarHistorico = async () => {
    if (!solicitacao) return;
    setIsLoadingHistorico(true);
    try {
      const data = await api.obterHistoricoCessao(solicitacao.codigo);
      setHistorico(data || []);
      if (data && data.length > 0) {
        setSelectedHistorico(data[0]);
      }
    } catch (err) {
      setHistorico([]);
      toast.error('Erro ao carregar histórico');
    } finally {
      setIsLoadingHistorico(false);
    }
  };

  const carregarDocumentoDigital = async () => {
    if (!solicitacao) return;
    setIsLoadingDocumento(true);
    try {
      const data = await obterDocumentoDigitalCessao(solicitacao.codigo);
      setDocumentoDigital(data);
    } catch (err) {
      setDocumentoDigital(null);
      console.log('Documento digital não disponível:', err);
    } finally {
      setIsLoadingDocumento(false);
    }
  };

  const carregarInfosBoleto = async () => {
    if (!solicitacao) return;
    setIsLoadingInfosBoleto(true);
    try {
      const data = await cessaoInfosBoleto(solicitacao.codigo);
      setInfosBoleto(data);
    } catch (err) {
      setInfosBoleto(null);
      console.log('Infos boleto não disponíveis:', err);
    } finally {
      setIsLoadingInfosBoleto(false);
    }
  };

  const handleDesbloquear = async () => {
    if (!solicitacao) return;
    setIsDesbloqueando(true);
    try {
      await desbloquearSolicitacaoCessao({
        codigo_solicitacao: solicitacao.codigo,
      });
      toast.success('Solicitação desbloqueada com sucesso!');
      carregarDetalhes();
      carregarHistorico();
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao desbloquear solicitação');
    } finally {
      setIsDesbloqueando(false);
    }
  };

  const abrirDocumentoPDF = () => {
    if (!documentoDigital) {
      toast.warning('Documento não disponível');
      return;
    }

    if (documentoDigital.url_documento) {
      window.open(documentoDigital.url_documento, '_blank');
      return;
    }

    if (documentoDigital.documento_pdf && documentoDigital.documento_pdf.length > 0) {
      try {
        const base64String = documentoDigital.documento_pdf;
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } catch (err) {
        toast.error('Erro ao abrir o documento PDF');
        console.error('Erro ao processar PDF:', err);
      }
    } else {
      toast.warning('Documento PDF não disponível');
    }
  };

  const handleConferir = (key, value) => {
    setConferencias(prev => ({
      ...prev,
      [key]: value,
    }));
    // Desmarcar a conferência elimina a marca efetiva de reprovação: o campo
    // volta a pendente, sai dos dois contadores de reprovados e o próximo
    // payload envia valido=null para ele.
    if (!value) {
      setCamposInvalidos(prev => {
        if (!(key in prev)) return prev;
        const proximo = { ...prev };
        delete proximo[key];
        return proximo;
      });
    }
  };

  const handleVerAnexo = async documento => {
    const identificadorDocumento = obterIdentificadorDocumento(documento);
    if (!identificadorDocumento) {
      toast.warning('Documento sem código para consulta. Acione o suporte.');
      return;
    }
    setErrosDownload(prev => {
      const novosErros = { ...prev };
      delete novosErros[identificadorDocumento];
      return novosErros;
    });
    try {
      const response = await downloadDocumentoCessao(identificadorDocumento);
      const url = window.URL.createObjectURL(response);
      window.open(url, '_blank');
    } catch (err) {
      console.error('Erro ao abrir documento:', err);
      const mensagem = obterMensagemFalhaDownload(documento);
      setErrosDownload(prev => ({
        ...prev,
        [identificadorDocumento]: mensagem,
      }));
      toast.error(mensagem);
    }
  };

  const handleValidarDocumento = (codigoDocumento, valido) => {
    if (
      codigoDocumento === null ||
      codigoDocumento === undefined ||
      codigoDocumento === ''
    ) {
      return;
    }
    setDocumentosValidacao(prev => ({
      ...prev,
      [codigoDocumento]: valido,
    }));
  };

  const handleMarcarInvalido = (campoKey, invalido) => {
    setCamposInvalidos(prev => ({
      ...prev,
      [campoKey]: invalido,
    }));
  };

  // Única fonte da classificação da conferência. Payload de envio,
  // contadores do card e alertas são todos projeções deste mesmo resultado —
  // nenhum deles recalcula pendência/reprovação por conta própria.
  const classificarConferencia = () =>
    classificarConferenciaCessao({
      detalhes,
      conferencias,
      camposInvalidos,
      documentosValidacao,
      editavelClientePersistido,
    });

  // Adaptador: mantém a assinatura já consumida por handleSalvarProgresso e
  // handleSubmitDecisao (`{ campos, erro }`), agora inteiramente derivada da
  // classificação única. Identidade ausente/ambígua de pessoa ou documento
  // sem código bloqueia o envio inteiro — nunca um payload parcial.
  // Aceita uma classificação já calculada para que handleSubmitDecisao reuse
  // a mesma avaliação usada no bloqueio, em vez de recalculá-la.
  const montarCamposConferencia = classificacaoJaCalculada => {
    const { payload, errosIdentidade } =
      classificacaoJaCalculada || classificarConferencia();
    if (errosIdentidade.length > 0) {
      return { campos: [], erro: errosIdentidade[0] };
    }
    return { campos: payload, erro: null };
  };

  const handleSalvarProgresso = async () => {
    if (!solicitacao) return;

    const { campos: camposConferencia, erro: erroIdentidade } =
      montarCamposConferencia();
    if (erroIdentidade) {
      toast.error(obterMensagemErroIdentidadeParticipante(erroIdentidade));
      return;
    }
    if (camposConferencia.length === 0) {
      toast.warning('Nenhum campo foi conferido ainda.');
      return;
    }

    setIsSavingProgress(true);
    try {
      await api.salvarConferenciaCamposCessao({
        codigo_solicitacao: solicitacao.codigo,
        campos: camposConferencia,
        observacao: 'Progresso da conferência salvo.',
      });

      toast.success('Progresso salvo com sucesso!');
      carregarHistorico();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao salvar progresso');
    } finally {
      setIsSavingProgress(false);
    }
  };

  const handleSubmitDecisao = async () => {
    if (!solicitacao || !decisao) return;

    if (decisao === 3 && !motivoReprovacao) {
      toast.error('Selecione o motivo da reprovação');
      return;
    }

    const analiseDocumentos = construirAnaliseDocumentos(detalhes);
    const classificacaoDecisao = classificarConferencia();
    const bloqueiosDecisao = obterBloqueiosDecisao({
      decisao,
      classificacao: classificacaoDecisao,
      documentosInconsistentes: analiseDocumentos.documentosInconsistentes,
    });
    if (bloqueiosDecisao.length > 0) {
      toast.error(bloqueiosDecisao[0]);
      return;
    }

    if (!observacao.trim()) {
      toast.error('Preencha a observação');
      return;
    }

    setIsSubmitting(true);
    try {
      const motivoEncontrado = MOTIVOS_REPROVACAO.find(
        m => m.value === motivoReprovacao
      );
      const obsCompleta =
        decisao === 3
          ? `${
              motivoEncontrado ? motivoEncontrado.label : motivoReprovacao
            }. ${observacao}`
          : observacao;

      const documentosValidacaoArray = Object.entries(documentosValidacao)
        .filter(([codigo]) => codigo !== '')
        .map(([codigo, valido]) => {
          const codigoDocumentoNumerico = Number(codigo);
          return {
            codigo_documento: Number.isNaN(codigoDocumentoNumerico)
              ? codigo
              : codigoDocumentoNumerico,
            valido,
          };
        });
      const { campos: camposConferencia, erro: erroIdentidade } =
        montarCamposConferencia(classificacaoDecisao);
      if (erroIdentidade) {
        toast.error(obterMensagemErroIdentidadeParticipante(erroIdentidade));
        return;
      }
      if (camposConferencia.length > 0) {
        await api.salvarConferenciaCamposCessao({
          codigo_solicitacao: solicitacao.codigo,
          campos: camposConferencia,
          observacao: obsCompleta,
        });
      }

      await api.alterarStatusCessao({
        codigo_solicitacao: solicitacao.codigo,
        codigo_etapa: solicitacao.codigo_etapa,
        codigo_sub_etapa: decisao,
        observacao: obsCompleta,
        enviar_email: enviarEmail,
        documentos_validacao: documentosValidacaoArray,
      });

      toast.success(
        decisao === 2
          ? 'Documentação aprovada com sucesso!'
          : 'Documentação reprovada com sucesso!'
      );
      onHide();
      if (onStatusChange) onStatusChange(false);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao alterar status');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Adaptador: total efetivamente reprovado (editável + não editável pelo
  // cliente). Pendente nunca entra aqui — a pendência de campos e anexos é
  // mostrada a partir da mesma classificação usada no bloqueio da decisão.
  const calcularCamposInvalidos = () => {
    if (!detalhes) return 0;
    const { reprovadosEditaveis, reprovadosNaoEditaveis } =
      classificarConferencia();
    return reprovadosEditaveis.length + reprovadosNaoEditaveis.length;
  };

  // Adaptador: detalhamento do total acima entre o que volta para correção
  // do cliente e o que exige atendimento interno. Mesma classificação única,
  // nunca uma lista paralela.
  const calcularReprovadosEditaveis = () => {
    if (!detalhes) return 0;
    return classificarConferencia().reprovadosEditaveis.length;
  };

  // Adaptador: substitui a antiga lista manual de sufixos, que classificava
  // E-mail e Telefone incorretamente como não editáveis, pela editabilidade
  // real de cada campo reprovado, já resolvida pela classificação única.
  const calcularReprovadosNaoEditaveis = () => {
    if (!detalhes) return 0;
    return classificarConferencia().reprovadosNaoEditaveis.length;
  };

  const temCamposInvalidosNaoEditaveis = () => calcularReprovadosNaoEditaveis() > 0;

  const podeAprovarReprovar = () => {
    return (
      detalhes && detalhes.codigo_sub_etapa === 1 && detalhes.codigo_etapa === 2
    );
  };

  const getStatusBadgeVariant = codigoSubEtapa => {
    switch (codigoSubEtapa) {
      case 2:
        return 'success';
      case 3:
        return 'danger';
      case 5:
        return 'info';
      default:
        return 'warning';
    }
  };

  const calcularTotalConferidos = () => {
    return Object.values(conferencias).filter(v => v === true).length;
  };

  const calcularTotalParaConferir = () => {
    if (!detalhes) return 0;
    let total = 0;
    (detalhes.cedentes || []).forEach(p => {
      total += obterChavesPessoa(p, 'cedente').length;
    });
    (detalhes.cessionarios || []).forEach(p => {
      total += obterChavesPessoa(p, 'cessionario').length;
    });
    if (detalhes.lote) {
      total += getLoteKeys().length;
    }
    total += getSolicitacaoKeys().length;
    return total;
  };

  const analiseDocumentos = detalhes
    ? construirAnaliseDocumentos(detalhes)
    : { documentos: [], documentosInconsistentes: [] };
  const resumoDocumental = construirResumoDocumental({
    documentos: analiseDocumentos.documentos,
    documentosValidacao,
    conferenciasDocumentais: conferenciasPersistidas,
  });
  // Classificação calculada uma única vez por avaliação e reutilizada tanto
  // no bloqueio renderizado/disabled quanto na revalidação de
  // handleSubmitDecisao — nunca duas fontes de verdade sobre pendência.
  const classificacaoDecisaoAtual = classificarConferencia();
  const pendentesCamposAtuais = classificacaoDecisaoAtual.pendentes.filter(
    item => item.tipo_registro !== 'DOCUMENTO'
  ).length;
  const pendentesAnexosAtuais = classificacaoDecisaoAtual.pendentes.filter(
    item => item.tipo_registro === 'DOCUMENTO'
  ).length;
  const bloqueiosDecisaoAtuais = decisao
    ? obterBloqueiosDecisao({
        decisao,
        classificacao: classificacaoDecisaoAtual,
        documentosInconsistentes: analiseDocumentos.documentosInconsistentes,
      })
    : [];

  if (!solicitacao) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <FaClipboardList className="mr-2" />
          Detalhes da Solicitação #{solicitacao.codigo}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: '70vh',
          overflowY: 'auto',
          backgroundColor: '#f8f9fa',
        }}
      >
        <div className="mb-3 p-3 bg-white rounded border shadow-sm">
          <Row>
            <Col md={4}>
              <small className="text-muted">Solicitante</small>
              <p className="mb-1 font-weight-bold">
                {solicitacao.nome_solicitante}
              </p>
            </Col>
            <Col md={4}>
              <small className="text-muted">CPF/CNPJ</small>
              <p className="mb-1">{formatCpfCnpj(solicitacao.cpf_cnpj)}</p>
            </Col>
            <Col md={4}>
              <small className="text-muted">Tipo Cessão</small>
              <p className="mb-1">{solicitacao.tipo_cessao}</p>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <small className="text-muted">Empreendimento</small>
              <p className="mb-1">{solicitacao.empreendimento}</p>
            </Col>
            <Col md={3}>
              <small className="text-muted">Quadra / Lote</small>
              <p className="mb-1">
                {solicitacao.quadra} / {solicitacao.lote}
              </p>
            </Col>
            <Col md={3}>
              <small className="text-muted">Etapa Atual</small>
              <p className="mb-1">
                <Badge variant="info">{solicitacao.etapa}</Badge>
              </p>
            </Col>
            <Col md={3}>
              <small className="text-muted">Status</small>
              <p className="mb-1">
                <Badge
                  variant={getStatusBadgeVariant(solicitacao.codigo_sub_etapa)}
                >
                  {solicitacao.sub_etapa}
                </Badge>
                {solicitacao.bloqueado && (
                  <Badge variant="danger" className="ml-2">
                    <FaLock size={10} /> Bloqueado
                  </Badge>
                )}
              </p>
            </Col>
          </Row>
          {(infosBoleto || isLoadingInfosBoleto) && (
            <Row className="mt-2">
              <Col md={6}>
                <small className="text-muted">Tipo da Taxa</small>
                <p className="mb-1">
                  {isLoadingInfosBoleto ? (
                    <FaSpinner className="fa-spin" />
                  ) : infosBoleto && infosBoleto.tipo_calculo ? (
                    <Badge variant="secondary">
                      {infosBoleto.taxa_boleto_tipo_calculo === 'F'
                        ? 'Valor Fixo'
                        : infosBoleto.taxa_boleto_tipo_calculo === 'P'
                        ? 'Percentual'
                        : 'Empreendimento'}
                    </Badge>
                  ) : (
                    '-'
                  )}
                  {infosBoleto && infosBoleto.descricao_taxa && (
                    <small className="ml-2 text-muted">
                      {limparZerosPercentual(infosBoleto.descricao_taxa)}
                    </small>
                  )}
                </p>
              </Col>
              <Col md={6}>
                <small className="text-muted">Valor da Taxa</small>
                <p className="mb-1 font-weight-bold">
                  {isLoadingInfosBoleto ? (
                    <FaSpinner className="fa-spin" />
                  ) : infosBoleto && infosBoleto.valor_taxa_apurado != null ? (
                    <span className="text-success">
                      <FaMoneyBillWave className="mr-1" />
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(infosBoleto.valor_taxa_apurado)}
                    </span>
                  ) : (
                    '-'
                  )}
                </p>
              </Col>
            </Row>
          )}
        </div>

        {isInativa && (
          <Alert variant="danger" className="mb-3">
            <FaLock className="mr-2" />
            <strong>Solicitação Inativa.</strong> Esta solicitação foi inativada. Apenas o histórico está disponível para visualização.
          </Alert>
        )}

        <Tabs
          activeKey={activeTab}
          onSelect={k => {
            if (isInativa && k !== 'historico' && k !== 'formulario') return;
            setActiveTab(k);
          }}
          className="mb-3"
        >
          <Tab
            eventKey="formulario"
            title={
              <>
                <FaFileAlt className="mr-1" /> Formulário
                {!isInativa && calcularTotalParaConferir() > 0 && (
                  <Badge variant="secondary" className="ml-2">
                    {calcularTotalConferidos()}/{calcularTotalParaConferir()}
                  </Badge>
                )}
              </>
            }
          >
            {isLoadingDetalhes ? (
              <div className="text-center py-4">
                <Loading />
              </div>
            ) : detalhes ? (
              <div className="p-2">
                <div style={isInativa ? { pointerEvents: 'none' } : undefined}>
                <Accordion defaultActiveKey={isInativa ? 'cedentes' : undefined} className="mb-3">
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="cedentes"
                      className="cursor-pointer bg-light"
                    >
                      <strong>
                        <FaUsers className="mr-2" />
                        Cedente(s) - Atual Proprietário
                      </strong>
                      <Badge variant="primary" className="ml-2">
                        {(detalhes.cedentes || []).length}
                      </Badge>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="cedentes">
                      <Card.Body className="p-2">
                        {(detalhes.cedentes || []).map((pessoa, indice) => (
                          <SecaoPessoa
                            key={obterChaveRenderizacaoParticipante(
                              pessoa,
                              'cedente',
                              indice
                            )}
                            pessoa={pessoa}
                            titulo={
                              pessoa.tipo === 'Principal'
                                ? 'Cedente Principal'
                                : pessoa.nome
                            }
                            tipo="cedente"
                            conferencias={conferencias}
                            onConferir={handleConferir}
                            onVerAnexo={handleVerAnexo}
                            documentosValidacao={documentosValidacao}
                            onValidarDocumento={handleValidarDocumento}
                            disabled={isSubmitting}
                            camposInvalidos={camposInvalidos}
                            onMarcarInvalido={handleMarcarInvalido}
                            errosDownload={errosDownload}
                          />
                        ))}
                        {(detalhes.cedentes || []).length === 0 && (
                          <p className="text-muted text-center py-3">
                            Nenhum cedente encontrado
                          </p>
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>

                <Accordion defaultActiveKey={isInativa ? 'cessionarios' : undefined} className="mb-3">
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="cessionarios"
                      className="cursor-pointer bg-light"
                    >
                      <strong>
                        <FaUsers className="mr-2" />
                        Cessionário(s) - Novo Proprietário
                      </strong>
                      <Badge variant="success" className="ml-2">
                        {(detalhes.cessionarios || []).length}
                      </Badge>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="cessionarios">
                      <Card.Body className="p-2">
                        {(detalhes.cessionarios || []).map((pessoa, indice) => (
                          <SecaoPessoa
                            key={obterChaveRenderizacaoParticipante(
                              pessoa,
                              'cessionario',
                              indice
                            )}
                            pessoa={pessoa}
                            titulo={
                              pessoa.tipo === 'Principal'
                                ? 'Cessionário Principal'
                                : pessoa.nome
                            }
                            tipo="cessionario"
                            conferencias={conferencias}
                            onConferir={handleConferir}
                            onVerAnexo={handleVerAnexo}
                            documentosValidacao={documentosValidacao}
                            onValidarDocumento={handleValidarDocumento}
                            disabled={isSubmitting}
                            camposInvalidos={camposInvalidos}
                            onMarcarInvalido={handleMarcarInvalido}
                            errosDownload={errosDownload}
                          />
                        ))}
                        {(detalhes.cessionarios || []).length === 0 && (
                          <p className="text-muted text-center py-3">
                            Nenhum cessionário encontrado
                          </p>
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>

                <SecaoLote
                  lote={detalhes.lote}
                  conferencias={conferencias}
                  onConferir={handleConferir}
                  onVerAnexo={handleVerAnexo}
                  documentosValidacao={documentosValidacao}
                  onValidarDocumento={handleValidarDocumento}
                  disabled={isSubmitting}
                  camposInvalidos={camposInvalidos}
                  onMarcarInvalido={handleMarcarInvalido}
                  errosDownload={errosDownload}
                />

                <SecaoSolicitacao
                  detalhes={detalhes}
                  conferencias={conferencias}
                  onConferir={handleConferir}
                  camposInvalidos={camposInvalidos}
                  onMarcarInvalido={handleMarcarInvalido}
                />
                <SecaoDocumentosInconsistentes
                  documentosInconsistentes={analiseDocumentos.documentosInconsistentes}
                  totalDocumentos={analiseDocumentos.documentos.length}
                  onVerAnexo={handleVerAnexo}
                  documentosValidacao={documentosValidacao}
                  onValidarDocumento={handleValidarDocumento}
                  disabled={isSubmitting}
                  errosDownload={errosDownload}
                />
                </div>

                {!isInativa && (<>
                <Card className="mt-4 mb-3">
                  <Card.Header className="bg-secondary text-white py-2">
                    <strong>
                      <FaClipboardList className="mr-2" />
                      Resumo da Conferência
                    </strong>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <ResumoDocumentalCard
                          resumo={resumoDocumental}
                          participantes={[
                            ...(detalhes.cedentes || []),
                            ...(detalhes.cessionarios || []),
                          ]}
                          inconsistenciasDocumentosAtuais={
                            analiseDocumentos.documentosInconsistentes.length
                          }
                        />
                      </Col>
                      <Col md={6}>
                        <div
                          className={`text-center p-3 rounded ${
                            calcularReprovadosNaoEditaveis() > 0
                              ? 'bg-danger text-white'
                              : 'bg-light'
                          }`}
                        >
                          <h4 className="mb-0">{calcularCamposInvalidos()}</h4>
                          <small
                            className={
                              calcularReprovadosNaoEditaveis() > 0
                                ? 'text-white'
                                : 'text-muted'
                            }
                          >
                            Campos reprovados
                          </small>
                          <div
                            className={`mt-1 small ${
                              calcularReprovadosNaoEditaveis() > 0
                                ? 'text-white'
                                : 'text-muted'
                            }`}
                          >
                            {calcularReprovadosEditaveis()} para correção do
                            cliente • {calcularReprovadosNaoEditaveis()} que
                            exigem atendimento interno
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {temCamposInvalidosNaoEditaveis() && (
                      <Alert variant="danger" className="mt-3 mb-0">
                        <FaLock className="mr-2" />
                        Há campos reprovados que não podem ser corrigidos no
                        autoatendimento. Ao confirmar a reprovação, a
                        solicitação será direcionada para atendimento interno.
                      </Alert>
                    )}
                    <div className="mt-3 text-center">
                      <Button
                        variant="outline-primary"
                        onClick={handleSalvarProgresso}
                        disabled={isSavingProgress || isSubmitting || calcularTotalConferidos() === 0}
                      >
                        {isSavingProgress ? (
                          <>
                            <FaSpinner className="fa-spin mr-2" />
                            Salvando...
                          </>
                        ) : (
                          <>
                            <FaFileAlt className="mr-2" />
                            Salvar Progresso
                          </>
                        )}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>

                {podeAprovarReprovar() ? (
                  <Card className="border-primary">
                    <Card.Header className="bg-primary text-white py-2">
                      <strong>
                        <FaCheckSquare className="mr-2" />
                        Decisão do Especialista
                      </strong>
                    </Card.Header>
                    <Card.Body>
                      {classificacaoDecisaoAtual.pendentes.length > 0 && (
                        <Alert variant="warning" className="mb-3">
                          <FaSquare className="mr-2" />
                          <strong>Pendências de conferência:</strong>{' '}
                          {MENSAGEM_DECISAO_INCOMPLETA} Campos pendentes:{' '}
                          {pendentesCamposAtuais}. Anexos pendentes:{' '}
                          {pendentesAnexosAtuais}.
                        </Alert>
                      )}

                      {obterParticipantesSemIdentificadorEstavel(detalhes).length > 0 && (
                        <Alert variant="danger" className="mb-3">
                          <FaExclamationTriangle className="mr-2" />
                          <strong>Identidade incompleta:</strong> há participante
                          sem identificador estável. A decisão não pode ser
                          concluída até o contrato de detalhe retornar esse
                          identificador.
                        </Alert>
                      )}

                      {analiseDocumentos.documentosInconsistentes.length > 0 && (
                        <Alert variant="danger" className="mb-3">
                          <FaExclamationTriangle className="mr-2" />
                          <strong>Documentos inconsistentes:</strong> resolva
                          os itens listados acima ou confirme a regra aplicável
                          antes de concluir a decisão.
                        </Alert>
                      )}

                      {decisao && bloqueiosDecisaoAtuais.length > 0 && (
                        <Alert variant="danger" className="mb-3">
                          <strong>Decisão bloqueada:</strong>
                          <ul className="mb-0 mt-1">
                            {bloqueiosDecisaoAtuais.map(bloqueio => (
                              <li key={bloqueio}>{bloqueio}</li>
                            ))}
                          </ul>
                        </Alert>
                      )}

                      <Row className="mb-3">
                        <Col md={6}>
                          <Button
                            variant={
                              decisao === 2 ? 'success' : 'outline-success'
                            }
                            block
                            size="lg"
                            onClick={() => setDecisao(2)}
                            disabled={isSubmitting}
                          >
                            <FaCheck className="mr-2" />
                            Aprovar
                          </Button>
                        </Col>
                        <Col md={6}>
                          <Button
                            variant={
                              decisao === 3 ? 'danger' : 'outline-danger'
                            }
                            block
                            size="lg"
                            onClick={() => setDecisao(3)}
                            disabled={isSubmitting}
                          >
                            <FaTimes className="mr-2" />
                            Reprovar
                          </Button>
                        </Col>
                      </Row>

                      {decisao === 3 && (
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Motivo da Reprovação{' '}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            options={MOTIVOS_REPROVACAO}
                            value={MOTIVOS_REPROVACAO.find(
                              m => m.value === motivoReprovacao
                            )}
                            onChange={opt =>
                              setMotivoReprovacao(opt ? opt.value : '')
                            }
                            styles={{
                              ...customStyles,
                              menuPortal: base => ({ ...base, zIndex: 9999 }),
                            }}
                            components={{ DropdownIndicator }}
                            placeholder="Selecione o motivo..."
                            menuPortalTarget={document.body}
                            isDisabled={isSubmitting}
                          />
                        </Form.Group>
                      )}

                      {decisao && (
                        <>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Observação <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={observacao}
                              onChange={e => setObservacao(e.target.value)}
                              placeholder={
                                decisao === 2
                                  ? 'Descreva os detalhes da aprovação...'
                                  : 'Descreva os detalhes da reprovação...'
                              }
                              disabled={isSubmitting}
                            />
                          </Form.Group>

                          <Form.Check
                            type="checkbox"
                            id="check-email-decisao"
                            label="Enviar e-mail ao cliente com a atualização"
                            checked={enviarEmail}
                            onChange={e => setEnviarEmail(e.target.checked)}
                            disabled={isSubmitting}
                            className="mb-3"
                          />

                          <Button
                            variant={decisao === 2 ? 'success' : 'danger'}
                            size="lg"
                            block
                            onClick={handleSubmitDecisao}
                            disabled={
                              isSubmitting ||
                              !observacao.trim() ||
                              (decisao === 3 && !motivoReprovacao) ||
                              bloqueiosDecisaoAtuais.length > 0
                            }
                          >
                            {isSubmitting ? (
                              <>
                                <FaSpinner className="fa-spin mr-2" />
                                Processando...
                              </>
                            ) : decisao === 2 ? (
                              <>
                                <FaCheck className="mr-2" />
                                Confirmar Aprovação
                              </>
                            ) : (
                              <>
                                <FaTimes className="mr-2" />
                                Confirmar Reprovação
                              </>
                            )}
                          </Button>
                        </>
                      )}
                    </Card.Body>
                  </Card>
                ) : (
                  <Alert variant="info" className="mt-3">
                    <strong>Status:</strong> {detalhes.sub_etapa || 'N/A'}
                    <br />
                    <small className="text-muted">
                      {detalhes.codigo_etapa === 2
                        ? 'A solicitação não está em análise. Use o botão abaixo para alterar o status manualmente.'
                        : 'A alteração de status só está disponível na etapa de Análise de Documentos.'}
                    </small>
                    {detalhes.codigo_etapa === 2 && (
                      <div className="mt-2">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => onStatusChange(true)}
                        >
                          <FaFileAlt className="mr-2" />
                          Alterar Status
                        </Button>
                      </div>
                    )}
                  </Alert>
                )}
                </>)}
              </div>
            ) : (
              <div className="p-3 text-center bg-white rounded border">
                <p className="text-muted py-4">
                  Não foi possível carregar os detalhes da solicitação.
                </p>
              </div>
            )}
          </Tab>

          <Tab
            eventKey="historico"
            title={
              <>
                <FaHistory className="mr-1" /> Histórico
              </>
            }
          >
            <div className="bg-white rounded border">
              {isLoadingHistorico ? (
                <div className="text-center py-4">
                  <Loading />
                </div>
              ) : historico.length === 0 ? (
                <p className="text-center text-muted py-4">
                  Nenhum registro no histórico
                </p>
              ) : (
                <Row className="m-0">
                  <Col
                    md={5}
                    className="border-right p-0"
                    style={{ maxHeight: '400px', overflowY: 'auto' }}
                  >
                    {historico.map((item, idx) => (
                      <div
                        key={item.codigo || idx}
                        className={`p-3 border-bottom cursor-pointer ${
                          selectedHistorico &&
                          selectedHistorico.codigo === item.codigo
                            ? 'bg-light'
                            : ''
                        }`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setSelectedHistorico(item)}
                      >
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="flex-grow-1">
                            <strong
                              className="d-block"
                              style={{ fontSize: '0.9rem' }}
                            >
                              {item.titulo}
                            </strong>
                            <small className="text-muted">
                              <FaClock size={10} className="mr-1" />
                              {moment(item.data_hora).format(
                                'DD/MM/YYYY HH:mm'
                              )}
                            </small>
                          </div>
                          <div className="text-right">
                            <small className="text-primary d-block">
                              <FaUser size={10} className="mr-1" />
                              {item.usuario || 'Sistema'}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Col>
                  <Col
                    md={7}
                    className="p-3"
                    style={{ backgroundColor: '#f8f9fa' }}
                  >
                    {selectedHistorico ? (
                      <div>
                        <h6 className="mb-3">{selectedHistorico.titulo}</h6>
                        <div className="mb-3">
                          <small className="text-muted d-block mb-1">
                            Data/Hora
                          </small>
                          <span>
                            {moment(selectedHistorico.data_hora).format(
                              'DD/MM/YYYY [às] HH:mm:ss'
                            )}
                          </span>
                        </div>
                        <div className="mb-3">
                          <small className="text-muted d-block mb-1">
                            Usuário
                          </small>
                          <span>{selectedHistorico.usuario || 'Sistema'}</span>
                        </div>
                        {selectedHistorico.etapa && (
                          <div className="mb-3">
                            <small className="text-muted d-block mb-1">
                              Etapa
                            </small>
                            <Badge variant="secondary">
                              {selectedHistorico.etapa}
                            </Badge>
                            {selectedHistorico.sub_etapa && (
                              <Badge
                                variant="outline-secondary"
                                className="ml-2"
                              >
                                {selectedHistorico.sub_etapa}
                              </Badge>
                            )}
                          </div>
                        )}
                        <div className="mb-3">
                          <small className="text-muted d-block mb-1">
                            Descrição
                          </small>
                          <p
                            className="mb-0 p-2 bg-white rounded border"
                            style={{ whiteSpace: 'pre-wrap' }}
                          >
                            {selectedHistorico.descricao || 'Sem descrição'}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-muted text-center py-4">
                        Selecione um item para ver os detalhes
                      </p>
                    )}
                  </Col>
                </Row>
              )}
            </div>
          </Tab>

          <Tab
            eventKey="termo"
            disabled={isInativa}
            title={
              <>
                <FaClipboardList className="mr-1" /> Visualizar Termo
              </>
            }
          >
            {isLoadingDocumento ? (
              <div className="p-3 bg-white rounded border text-center">
                <Loading />
                <p className="text-muted mt-2">Carregando documento...</p>
              </div>
            ) : (
              <div className="p-3 bg-white rounded border">
                <Row>
                  <Col md={6} className="border-right">
                    <div className="p-3">
                      <h6 className="mb-4 text-center">
                        <FaFileAlt className="mr-2" />
                        Documento Gerado
                      </h6>
                      <div className="text-center">
                        <Button
                          variant="primary"
                          size="lg"
                          className="mb-2"
                          onClick={abrirDocumentoPDF}
                          disabled={!documentoDigital}
                        >
                          <FaFilePdf className="mr-2" />
                          {documentoDigital && documentoDigital.nome_arquivo
                            ? documentoDigital.nome_arquivo
                            : 'Termo de Cessão de Transferência'}
                        </Button>
                        <br />
                        <small className="text-muted">
                          {documentoDigital
                            ? 'Clique para visualizar o arquivo'
                            : 'Documento não disponível'}
                        </small>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="p-3">
                      <h6 className="mb-4 text-center">
                        <FaFileAlt className="mr-2" />
                        Assinatura Digital Solicitada
                      </h6>
                      <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th>Pré-Venda</th>
                              <th>Status</th>
                              <th className="text-center">ClickSign</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {documentoDigital && documentoDigital.numero_pre_venda
                                  ? documentoDigital.numero_pre_venda
                                  : 'N/A'}
                              </td>
                              <td>
                                <Badge variant="info" style={{ fontSize: '0.75rem' }}>
                                  {(() => {
                                    if (!documentoDigital) return 'Pendente';
                                    switch (documentoDigital.status_documento) {
                                      case 0: return 'Contrato Físico';
                                      case 1: return 'Solicitado';
                                      case 2: return 'Aprovado';
                                      case 3: return 'Reprovado';
                                      case 4: return 'Descartado';
                                      case 5: return 'Aguardando Assinatura Cliente';
                                      case 6: return 'Aguardando Assinatura Setpar';
                                      case 7: return 'Cancelado';
                                      case 8: return 'Finalizado';
                                      case 9: return 'Enviado';
                                      case 10: return 'Implantado';
                                      case 11: return 'Gravado';
                                      default: return 'Pendente';
                                    }
                                  })()}
                                </Badge>
                              </td>
                              <td className="text-center">
                                {documentoDigital && documentoDigital.codigo_documento_digital ? (
                                  <a
                                    href={`/documentodigital?codDocDigital=${documentoDigital.codigo_documento_digital}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Abrir solicitação do documento digital"
                                  >
                                    <FaExternalLinkAlt className="text-primary" size={16} />
                                  </a>
                                ) : (
                                  <span className="text-muted" title="Link não disponível">
                                    <FaFileAlt size={16} />
                                  </span>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        {!isInativa && solicitacao.bloqueado &&
          solicitacao.codigo_sub_etapa === 5 && (
            <Button
              variant="outline-danger"
              onClick={handleDesbloquear}
              disabled={isDesbloqueando || isSubmitting}
              className="d-inline-flex align-items-center mr-auto"
            >
              {isDesbloqueando ? (
                <>
                  <FaSpinner className="fa-spin mr-2" />
                  Desbloqueando...
                </>
              ) : (
                <>
                  <FaLockOpen className="mr-2" />
                  Desbloquear
                </>
              )}
            </Button>
          )}
        <Button
          variant="warning"
          onClick={onHide}
          className="d-inline-flex align-items-center"
        >
          <FaWindowClose className="mr-2" />
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetalhes;

export { DocumentoItem, SecaoDocumentosInconsistentes, SecaoPessoa };
